"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationDynamicCodeForResetLoginPwdRequest = void 0;
var VerificationDynamicCodeForResetLoginPwdRequest = /** @class */ (function () {
    function VerificationDynamicCodeForResetLoginPwdRequest() {
    }
    return VerificationDynamicCodeForResetLoginPwdRequest;
}());
exports.VerificationDynamicCodeForResetLoginPwdRequest = VerificationDynamicCodeForResetLoginPwdRequest;
;
//# sourceMappingURL=verificationDynamicCodeForResetLoginPwd.request.js.map